export default "__VITE_ASSET__I30ySorO__"